module.exports = __webpack_public_path__ + "img/f.d455dfea.png";